$bog_card_footer $mol_view sub /
	<= Start $mol_view sub / <= start \
	<= Center $mol_view sub / <= center \
	<= End $mol_view sub / <= end \
